module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/147assets/fonts/fa2772327f55d8198301fdb8bcfc8158.woff";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = 754
// module chunks = 4